/**
 * Property Status Mapping
 *
 * Centralized configuration for property statuses and filters
 */

/**
 * Property status values
 */
export const PROPERTY_STATUS = {
  FOR_SALE: "For Sale",
  SSTC: "Sold STC",
  UNDER_OFFER: "Under Offer",
  OFF_MARKET: "Off Market",
};

/**
 * Age filter options (in days)
 */
export const AGE_FILTERS = {
  LAST_30: 30,
  LAST_90: 90,
  ANYTIME: 999, // No age restriction
};

/**
 * Mailed status options
 */
export const MAILED_STATUS = {
  MAILED: "mailed",
  NOT_MAILED: "not_mailed",
};

/**
 * Get display label for property status
 */
export const getPropertyStatusLabel = (status) => {
  const labels = {
    [PROPERTY_STATUS.FOR_SALE]: "For Sale",
    [PROPERTY_STATUS.SSTC]: "SSTC",
    [PROPERTY_STATUS.UNDER_OFFER]: "Under Offer",
    [PROPERTY_STATUS.OFF_MARKET]: "Off Market",
  };
  return labels[status] || "UNKNOWN";
};

/**
 * Get display label for age filter
 */
export const getAgeFilterLabel = (days) => {
  if (days <= AGE_FILTERS.LAST_30) return "Last 30 days";
  if (days <= AGE_FILTERS.LAST_90) return "Last 90 days";
  return "Anytime";
};

/**
 * Get display label for mailed status
 */
export const getMailedStatusLabel = (status) => {
  return status === MAILED_STATUS.MAILED ? "Mailed" : "Not Mailed";
};
